export const metricNameCellStyles = {
    padding: "0 !important",
    border: '1px solid #E4E4E4',
    "&:hover": {
        border: '1px solid #E4E4E4',
        transition: "none",
    }
}

// Dumped Code

// {
//     accessorKey: "month_actual",
//     header: "Month Actual",
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={"Month Actual"} width={`200px`} />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//   },
//   {
//     accessorKey: "month_goal",
//     header: "Month Goal",
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={"Month Goal"} width={`200px`} />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//   },
//   {
//     accessorKey: "month_projected",
//     header: `Month Projected`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Month Projected`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "month_projected_vs_goal",
//     header: `Month Projected vs Goal`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader
//         headerName={`Month Projected vs Goal`}
//         width={`200px`}
//       />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "year_actual",
//     header: `Year Actual`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Year Actual`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "year_goal",
//     header: `Year Goal`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Year Goal`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "year_projected",
//     header: `Year Projected`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Year Projected`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "year_projected_vs_goal",
//     header: `Year Projected vs Goal`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader
//         headerName={`Year Projected vs Goal`}
//         width={`200px`}
//       />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "pytd_vs_cytd",
//     header: `Pytd vs Cytd`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Pytd vs Cytd`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "py_vs_ttm",
//     header: `Py vs Ttm`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Py vs Ttm`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "trend",
//     header: `Trend`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Trend`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "current_actual",
//     header: `Current Actual`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Current Actual`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "current_percent_of_total",
//     header: `Current Percent of Total`,
//     Header: ({ row }: any) => (
//       <OpportunityHeader
//         headerName={`Current Percent of Total`}
//         width={`200px`}
//       />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "current_goal",
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Current Goal`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "current_trend",
//     Header: ({ row }: any) => (
//       <OpportunityHeader headerName={`Current Trend`} width={`200px`} />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "current_trend_percent_of_total",
//     Header: ({ row }: any) => (
//       <OpportunityHeader
//         headerName={`Current Trend Percent of Total`}
//         width={`250px`}
//       />
//     ),
//     minSize: 250,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },
//   {
//     accessorKey: "current_vs_ttm_average",
//     Header: ({ row }: any) => (
//       <OpportunityHeader
//         headerName={`Current vs TTM Average`}
//         width={`200px`}
//       />
//     ),
//     size: 200,
//     Filter: ({ header, column }: any) => (
//       <MetricOpportunityColumnFilter
//         header={header}
//         column={column}
//         filterColors={filterColors}
//       />
//     ),
//     Cell: ({ column, row, renderedCellValue }: any) => (
//       <OpportunityCell
//         row={row}
//         renderedCellValue={renderedCellValue}
//         column={column}
//       />
//     ),
//   },